import ContactSummary from '@/generated/controls/contact/ContactSummary.vue';
import Contact from '@/generated/classes/Contact';
import Owner from '@/extend/classes/Owner';
import ListData from '@/extend/classes/ListData';
import Salarie from '@/extend/classes/Salarie';
import { Sections } from '@/generated/classes/AppSchema';
import { defineComponent } from "vue";

export default defineComponent({
  extends: ContactSummary,
  name: 'ContactSummaryExtend',
  components: {},
  computed: {
    display(): string {
      const value = this.value;
      const item = this.items.find(a => a.key == value)
      this.changeContext();
      if (item) {
        if (this.resetToggle()) {
          this.setStatusUpdated(true);
          this.statusUpdated(this.status);
        }
        const itemDefined = item;
        const contact = this.listContact.find(a => a.id == itemDefined.key);
        if (contact && contact.id != this.selectedContactId) {
          this.setSelectedContact(contact);
        }
        if (item.key == 0 && this.selectedContactId == 0) {
          this.setSelectedContact(this.newContact());
        }
        this.setSelectedContactId(contact ? contact.id : this.selectedContact.id);
      }
      const res = item && item.key != 0 ? item.title : '';
      if (this.cancelChanges && item) {
        this.itemChanged(item.key);
      }
      this.setAttribut(this.selectedContact, this.owner, this.parentObj)
      return res
    },
  },
  methods: {
    loadItems(): Promise<boolean> {
      this.reset = this.toggleReset;
      const excludeSalaries = this.sectionName == Sections.ETABLISSEMENT_CONTACTS ||
        this.sectionName == Sections.ETABLISSEMENT_REPRESENTANT;
      const salarieIds = excludeSalaries
        ? Salarie.idsByEtablissement(this.owner.objId).catch(() => [])
        : Promise.resolve([] as number[]);

      return Promise.all([Contact.list(this.filter), salarieIds])
        .then(([data, ids]: [ListData, number[]]) => {
          const excludedIds = new Set(ids);
          const items = data.reccords as Contact[];
          this.listContact = [];
          items.forEach((item) => {
            if (item.clientId != -1 && (!excludeSalaries || !excludedIds.has(item.id))) {
              this.listContact.push(Contact.fromJson(item));
            }
          })
          this.listUpdated = true;
          return true;
        })
        .catch(() => false);
    },
    getDisplay(contact: Contact): string {
      return contact.nom + ' ' + contact.prenom;
    },
    setAttribut(contact: Contact, owner: Owner, parentObj: unknown): void {
      contact.owner = owner;
    },
    setSelectedContact(contact: Contact) {
      this.selectedContact = contact;
      if (contact.id > 0) {
        if (contact.numeroId == 0 || contact.mailId == 0 || contact.qualiteId == 0 || contact.civiliteId == 0) {
          this.dialogOpen = true;
        }
      }
    }
  }
});
